import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import type { RootState } from './utils/store'
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<ThunkDispatch<RootState, void, Action>>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector